import React, { Component } from 'react'
import './index.css'

class BsyAlertTip extends Component {
    render() {
        const { type, msg } = this.props
        return (
            <div className={"content " + type}>
                <i className={"icon-" + type} />
                <span dangerouslySetInnerHTML={{__html:msg}}/>
            </div>
        )
    }
}

export default BsyAlertTip